<div
  class="container-fluid m-0 p-5 block"
  [ngClass]="{ 'theme-darkk': themeService.flag }"
>
  <div class="text-center">
    <h2 class="font-pacifico">
      <span class="text-underline cursor-pointer" (click)="navigate('\skills')"
        >Skills</span
      >.
    </h2>
  </div>
  <p class="tagline font-raleway">
    I am a Full Stack Developer in MEAN/MERN Stack and an App Developer (Hybrid
    using React Native and Ionic Framework).
  </p>
  <div
    class="skill row row-12 justify-content-center align-items-center p-3 m-2"
    *ngFor="let keys of getKeys(homeSkills)"
  >
    <div class="h2 text-center">{{ getHeading(keys) }}:</div>
    <div class="mx-sm-3 mx-md-5 row justify-content-center">
      <div
        class="card skill-card m-2 p-2 depth"
        *ngFor="let skill of homeSkills[keys]; let i = index"
        [ngClass]="{ 'theme-darkk text-light depth-light': themeService.flag }"
        (mouseover)="flip(i, true, keys)"
        (mouseout)="flip(i, false, keys)"
      >
        <div class="m-auto" *ngIf="!skill.flag">
          <img [src]="skill.image" [alt]="skill.text" class="img-fluid" />
        </div>
        <div
          class="m-auto skill-flip text-center"
          *ngIf="skill.flag"
        >
          <span class="font-raleway skill-text">{{ skill.text }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <button
      type="button"
      class="btn mybtn depth m-3 mt-4"
      [ngClass]="{ 'mybtn-dark': themeService.flag }"
      (click)="navigate('/skills')"
    >
      <fa-icon [icon]="faInfoCircle"></fa-icon>
      <span class="h5 ml-2">Know More...</span>
    </button>
  </div>
</div>
